import { PollPinSettingsText } from '@lessonup/pins-shared';
import React from 'react';
import { ParsedTextTipTapViewer } from '../../../../../components/Tiptap/ParsedTextTipTapViewer';
import { PollTextAnswerCard } from './PollTextAnswerCard';
import { PollTextAnswerContainer } from './PollTextAnswerContainer';

export interface TextPollAnswerAreaContentProps {
  pinSettings: Pick<PollPinSettingsText, 'answers'>;
  isInteractive?: boolean;
  selectedAnswerId?: string;
  onAnswerClick?: (answerId: string) => void;
}

export function TextPollAnswerAreaContent({
  pinSettings: { answers },
  isInteractive = false,
  selectedAnswerId,
  onAnswerClick,
}: TextPollAnswerAreaContentProps) {
  return (
    <PollTextAnswerContainer>
      {answers.map((answer, index) => (
        <PollTextAnswerCard
          key={`poll-answer-${answer.id}`}
          index={index}
          answer={answer}
          onClick={onAnswerClick ? () => onAnswerClick(answer.id) : undefined}
          active={selectedAnswerId === answer.id}
          isInteractive={isInteractive || !!onAnswerClick}
        >
          <ParsedTextTipTapViewer content={answer.text} />
        </PollTextAnswerCard>
      ))}
    </PollTextAnswerContainer>
  );
}
